import styled from "styled-components"

import Icon, { IconType } from "~/components/atoms/Icon"
import { Color, LineHeight, TextSize } from "~/consts/style-mixins"

interface Props {
  type: keyof typeof Type
  iconPath?: string
  iconName?: IconType
  name: string
  className?: string
}

export const Type = {
  Small: "Small",
}

const User = ({ iconPath, iconName, name, className }: Props) => {
  return (
    <Container className={className}>
      {iconPath && <img className="user-img" src={iconPath} alt={`${name}のアイコン`} />}
      {iconName && (
        <div className="user-icon">
          <Icon type={iconName} color={Color.LightGray} size={24} />
        </div>
      )}
      <div className="user-name">{name}</div>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  .user-img {
    border: 1px solid ${Color.BorderGray};
    border-radius: 50%;
    object-fit: cover;
    font-size: ${TextSize["2XS"]}px;
    background: white;
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .user-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${Color.BorderGray};
    border-radius: 50%;
    font-size: ${TextSize["2XS"]}px;
    background: white;
    width: 32px;
    height: 32px;
    margin-right: 8px;
  }
  .user-name {
    font-size: ${TextSize.XS}px;
    color: ${Color.Gray};
    line-height: ${LineHeight.S}%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export default User
